<template lang="pug">
  video.video-js.vjs-fluid.vjs-big-play-centered(
    id="videoPlayer"
  )
</template>
<script>
/* eslint-disable */
import video_css from 'video.js/dist/video-js.min.css';
import videojs from 'video.js';
/* eslint-enable */
export default {
  name: 'VideoPlayer',
  props: {
    videoSrc: String,
    thumbnailUrl: String,
    videoUuid: String,
    isSlideDrawerActive: Boolean,
    videoComponentType: String,
  },
  data: () => {
    return {
      player: null,
      options: {
        controlBar: {
          volumePanel: false,
          fullscreenToggle: false,
          pictureInPictureToggle: false,
        },
        autoplay: false,
        aspectRatio: '16:9',
        controls: true,
      },
    };
  },
  watch: {
    isSlideDrawerActive(value) {
      if (!value && this.videoComponentType === 'preview') this.resetPlayer();
    },
    videoComponentType(value) {
      if (value !== 'preview') this.resetPlayer();
    },
    videoUuid() {
      this.updatePlayer();
    },
  },
  mounted() {
    this.player = videojs(document.getElementById('videoPlayer'), this.options);
    this.updatePlayer();
  },
  methods: {
    resetPlayer() {
      this.player.reset();
      this.updatePlayer();
    },
    updatePlayer() {
      this.player.src(this.videoSrc);
      this.player.poster(this.thumbnailUrl);
    },
  },
};
</script>
